import { render } from "./TrainDetailView.vue?vue&type=template&id=58ba2528&scoped=true"
import script from "./TrainDetailView.vue?vue&type=script&lang=js"
export * from "./TrainDetailView.vue?vue&type=script&lang=js"

import "./TrainDetailView.vue?vue&type=style&index=0&id=58ba2528&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ba2528"]])

export default __exports__